import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import { useState, useContext, useEffect } from "react";
import {
  BASE_URL,
  FacultyPerformance,
} from "utilFunctions/Constants/urlConstants";
import Paginator from "utilFunctions/shared/Paginator";
import { removeEmptyFields } from "utilFunctions/helperFunctions/HelperFunction";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import useMasterContext from "Context/MasterContext";
import FacultiesFilter from "Pages/Faculties/FacultiesFilter";
import { Card } from "reactstrap";
import FacultiesRegions from "Pages/Faculties/FacultiesRegions";
import FacultiesBranches from "Pages/Faculties/FacultiesBranches";
import FacultyHealthHeader from "./FacultyHealthHeader";
import { useLocation } from "react-router-dom";
import dayjs, { Dayjs } from "dayjs";
import { FacultyPerformanceContext } from "Context/FacultyPerformanceContext";

const SORT_ASC = "ASC";
export const returnDateString = (date: any) => {
  let month = (date.get("month") + 1).toString();
  const year = date.get("year");
  if (month && month.length <= 1) {
    month = "0" + month;
  }
  const dateString = year + "-" + month;
  return dateString;
};
export const getMonthsBetweenDates = (start: Dayjs, end: Dayjs) => {
  const result: string[] = [];
  let current = start.clone();
  while (current.isBefore(end) || current.isSame(end, "month")) {
    result.push(current.format("YYYY-MM"));
    current = current.add(1, "month");
  }
  return result;
};
export const aggregatedorder: string[] = [
  "totalFacultiesCount",
  "markedLectures",
  "unmarkedLectures",
  "overAllRating",
  "totalFeedbacksCount",
  "classBehaviour",
  "teachingPace",
  "doubtResolution",
];
export type DataObject = {
  [key: string]: number;
};

const RegionsHeading = [
  { label: "Region Name", value: "branchOrRegionName" },
  { label: "Total Faculties", value: "totalFacultiesCount" },
  { label: "Marked Lectures %", value: "markedLectureCount" },
  { label: "Unmarked Lectures", value: "unmarkedLectureCount" },
  { label: "Marked Attendance %", value: "markedAttdCount" },
  { label: "Overall Ratings", value: "overallRatingAvg" },
  { label: "No. of feedbacks", value: "numberOfFeedbacks" },
  { label: "Students interaction", value: "followUpCount" },
];
const BranchedHeading = [
  { label: "Branch Name", value: "branchOrRegionName" },
  { label: "Total Faculties", value: "totalFacultiesCount" },
  { label: "Marked Lectures %", value: "markedLectureCount" },
  { label: "Unmarked Lectures", value: "unmarkedLectureCount" },
  { label: "Marked Attendance %", value: "markedAttdCount" },
  { label: "Overall Ratings", value: "overallRatingAvg" },
  { label: "No. of feedbacks", value: "numberOfFeedbacks" },
  { label: "Students interaction", value: "followUpCount" },
];
function FacultiesMain() {
  const location = useLocation();
  const { screen }: any = useWindowSize();
  const userInfo = useContext<any>(UserInfoContext);
  const { facultyPerformance } = useContext(FacultyPerformanceContext);
  const ToastDispatch = useContext(ToastContextDispatch);
  const { masters } = useMasterContext();
  const { regions } = masters;
  const [BranchData, setBranchData] = useState<any>([]);
  const [sortOrder, setSortOrder] = useState(SORT_ASC);
  const [sortColumn, setSortColumn] = useState<any>("branchOrRegionName");
  const [region, setRegion] = useState<any>([]);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardAggregatedData, setCardAggregatedData] = useState<any>(null);
  const currentMonth = dayjs().startOf("month");
  const nextMonth = dayjs().endOf("month"); // December of the current year

  const [dates, setDates] = useState<[Dayjs | null, Dayjs | null] | null>([
    currentMonth,
    nextMonth,
  ]);
  const dateFilterValues: any = dates;
  const [filterState, setFilterState] = useState<any>({
    region: null,
    streamIds:
      userInfo?.userStreams && userInfo?.userStreams[0] != undefined
        ? userInfo?.userStreams[0]
        : null,
    test: null,
    subject: null,
    branch: null,
    yearMonth: [dateFilterValues[0]],
  });
  const [pagination, setPagination] = useState({
    totalCount: "",
    totalPage: "",
    currentPage: "",
    nextPage: "",
    nextPageUrl: "",
    previousPageUrl: "",
  });

  const processResponseForCardData = (data: any, aggregatedData: any): [] => {
    if (data !== null) {
      Object.keys(data).forEach((key) => {
        if (Object.hasOwnProperty.call(data, key)) {
          aggregatedData.push({
            label: key,
            value:
              key === "overAllRating" && data[key] === 0 ? "NA" : data[key],
          });
        }
      });
    }
    return aggregatedData;
  };
  const { makeRequest: GetBranchData, loading: tableloading } = useGetApi(
    (data) => {
      if (
        data["data"] &&
        data["data"] &&
        data["data"]["facultyFeedbackResponse"]
      ) {
        if (location.pathname.includes("regions")) {
          setRegion(data["data"]["facultyFeedbackResponse"]);
        } else {
          setBranchData(data["data"]["facultyFeedbackResponse"] || []);
        }

        const aggredatedDataList = data["data"]["facultyOverAllCardDetails"];
        const reorderedData: DataObject = {};
        aggregatedorder.forEach((key) => {
          if (Object.prototype.hasOwnProperty.call(aggredatedDataList, key)) {
            reorderedData[key] = aggredatedDataList[key];
          }
        });
        setCardAggregatedData(reorderedData);
        setPagination({
          totalCount: data.totalCount,
          totalPage: data.totalPage,
          currentPage: data.currentPage,
          nextPage: data?.nextPage ? data.nextPage : 0,
          previousPageUrl: data?.previousPageUrl ? data.previousPageUrl : "",
          nextPageUrl: data?.nextPageUrl ? data.nextPageUrl : "",
        });
      } else {
        setBranchData([]);
        setCardAggregatedData(null);
      }
    },
    (error) => {
      setBranchData([]);
      setCardAggregatedData(null);
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );

  const onSelectClickHandler = (data: any) => {
    let url = BASE_URL + FacultyPerformance;
    url = url + "?facultyId=" + data?.branchId;
    if (location.pathname.includes("regions")) {
      url = url + "&fetchAllRegions=true&yearMonth=2024-04";
    }
    GetBranchData(url);
  };

  function getRegionNameByRegionId(inputKey: any): string | undefined {
    if (regions && regions !== undefined) {
      const region = regions.find((obj: any) => obj.key === inputKey);
      return region ? region.label : "";
    } else {
      return "";
    }
  }

  const fetchBranchHeader = () => {
    const regionId =
      location.pathname.split("/")[location.pathname.split("/").length - 1];
    const regionName = ` ${getRegionNameByRegionId(parseInt(regionId))} | ${
      pagination.totalCount
    } Branches`;
    return regionName;
  };

  useEffect(() => {
    if (Object.keys(facultyPerformance).length) {
      setFilterState({
        ...filterState,
        subject: facultyPerformance?.subject,
        streamIds: facultyPerformance?.streamIds,
        yearMonth: facultyPerformance?.yearMonth,
      });
      setDates(facultyPerformance?.yearMonth);
    } else {
      setFilterState({
        region: null,
        streamIds:
          userInfo?.userStreams && userInfo?.userStreams[0] != undefined
            ? userInfo?.userStreams[0]
            : null,
        clazz: null,
        branch: null,
        yearMonth: [dateFilterValues[0]],
      });
    }
  }, [masters.streams, facultyPerformance]);

  useEffect(() => {
    let regionId = "";
    const filterLength = Object.values(filterState).filter(
      (ele) => ele != null
    ).length;
    if (Object.keys(facultyPerformance).length) {
      applyFilter(facultyPerformance);
    } else {
      if (masters.streams && masters.streams[0] != undefined) {
        const streamId = masters.streams[0]?.value;
        let url =
          BASE_URL +
          FacultyPerformance +
          "?sortBy=" +
          sortColumn +
          "&sortDir=" +
          sortOrder;
        if (location.pathname.includes("regions")) {
          url = url + "&fetchAllRegions=true";
        } else {
          fetchBranchHeader();
          regionId =
            location.pathname.split("/")[
              location.pathname.split("/").length - 1
            ];
          url = url + `&regionCode=${regionId}`;
        }
        if (filterLength) {
          applyFilter(filterState);
        } else {
          GetBranchData(
            `${url}&limit=${limit}&offset=${0}&streamIds=${streamId}&yearMonth=${returnDateString(
              dateFilterValues[0]
            )}`
          );
        }
      }
    }
  }, [
    userInfo,
    masters.streams,
    currentPage,
    limit,
    sortColumn,
    sortOrder,
    location,
  ]);
  const applyFilter = (filterStateObj: any) => {
    const filterLength = Object.values(filterStateObj).filter(
      (ele) => ele != null
    ).length;
    if (filterLength) {
      const obj = {
        streamIds: filterStateObj.streamIds
          ? filterStateObj.streamIds.value
          : masters.streams[0].value,
        // region: filterStateObj.region?.value,
        subject: filterStateObj.subject?.value,
        branch: filterStateObj.branch?.map((item: any) => item.id)?.toString(),
        yearMonth:
          filterStateObj.yearMonth && filterStateObj.yearMonth.length > 0
            ? getMonthsBetweenDates(
                filterStateObj.yearMonth[0],
                filterStateObj.yearMonth[1]
              )
            : returnDateString(dateFilterValues[0]),
      };
      const filters2: any = [];
      const formValues: any = removeEmptyFields(obj);
      for (const key in formValues) {
        if (Object.prototype.hasOwnProperty.call(formValues, key)) {
          if (formValues[key] != null && formValues[key] != "") {
            filters2.push(
              encodeURIComponent(key) +
                "=" +
                encodeURIComponent(formValues[key])
            );
          }
        }
      }
      let url = BASE_URL + FacultyPerformance;
      if (Array.isArray(filters2) && filters2.length > 0) {
        url = url + "?" + filters2.join("&");
      } else {
        url = url + "?";
      }
      url = url + "&sortBy=" + sortColumn + "&sortDir=" + sortOrder;
      if (location.pathname.includes("regions")) {
        url = url + "&fetchAllRegions=true";
      } else {
        const regionId =
          location.pathname.split("/")[location.pathname.split("/").length - 1];
        url = url + `&regionCode=${regionId}`;
      }
      GetBranchData(`${url}&limit=${limit}&offset=${0}`);
    }
  };
  const resetHandler = () => {
    const streamId = masters.streams[0]?.value;
    let url = BASE_URL + FacultyPerformance;
    if (location.pathname.includes("regions")) {
      url =
        url +
        "?fetchAllRegions=true" +
        `&streamIds=${streamId}&yearMonth=${returnDateString(
          dateFilterValues[0]
        )}`;
      GetBranchData(`${url}&limit=${limit}&offset=${0}`);
    } else {
      const regionId =
        location.pathname.split("/")[location.pathname.split("/").length - 1];
      GetBranchData(
        `${url}?limit=${limit}&offset=${0}&regionCode=${regionId}&streamIds=${streamId}&yearMonth=${returnDateString(
          dateFilterValues[0]
        )}`
      );
    }
    setFilterState({
      region: null,
      streamIds:
        masters.streams && masters.streams[0] != undefined
          ? masters.streams[0]
          : null,
      subject: null,
      branch: null,
      yearMonth: [dateFilterValues[0]],
    });
    setDates([currentMonth, nextMonth]);
  };
  const onLimitChange = (limit: number) => {
    setLimit(limit);
  };
  const returnComponent = (pathName: string) => {
    switch (pathName) {
      case "regions":
        return (
          <>
            <FacultiesRegions
              data={region}
              tableHeading={RegionsHeading}
              loader={tableloading}
              sortColumn={sortColumn}
              sortOrder={sortOrder}
              setSortColumn={setSortColumn}
              setSortOrder={setSortOrder}
              screen={screen}
            />
          </>
        );
      case "branches":
        return (
          <>
            <FacultiesBranches
              data={BranchData}
              tableHeading={BranchedHeading}
              loader={tableloading}
              sortColumn={sortColumn}
              sortOrder={sortOrder}
              setSortColumn={setSortColumn}
              setSortOrder={setSortOrder}
              screen={screen}
              regionId={
                location.pathname.split("/")[
                  location.pathname.split("/").length - 1
                ]
              }
              streamId={filterState.streamIds}
            />
          </>
        );
      default:
        break;
    }
  };
  const returnPaginationComponent = (pathName: string) => {
    switch (pathName) {
      case "regions":
        return (
          <div
            className={
              !["xs", "sm", "md"].includes(screen)
                ? "batchTableContainer pt-0 pb-1"
                : "ml-2 mr-2 mt-3"
            }
          >
            <Card className="p-3 mb-2 mb-1">
              <Paginator
                module={"test"}
                pagination={pagination}
                pageChanged={(page: any) => setCurrentPage(page)}
                handlePaginationCall={(url: string) => {
                  GetBranchData(url);
                }}
                totalItems={pagination.totalCount}
                limit={limit}
                onLimitChange={onLimitChange}
              />
            </Card>
          </div>
        );
      case "branches":
        return (
          <div
            className={
              !["xs", "sm", "md"].includes(screen)
                ? "batchTableContainer pt-0 pb-1"
                : "ml-2 mr-2 mt-3"
            }
          >
            <Card className="p-3 mb-2 mb-1">
              <Paginator
                module={"test"}
                pagination={pagination}
                pageChanged={(page: any) => setCurrentPage(page)}
                handlePaginationCall={(url: string) => {
                  GetBranchData(url);
                }}
                totalItems={pagination.totalCount}
                limit={limit}
                onLimitChange={onLimitChange}
              />
            </Card>
          </div>
        );
      default:
        break;
    }
  };
  console.log("+++++dates+++++", dates);
  return (
    <>
      <FacultiesFilter
        mode="facultyPerformance"
        onSelectClickHandler={(data: any) => onSelectClickHandler(data)}
        region={region}
        subjects={userInfo?.subjectsListing}
        applyFilter={applyFilter}
        filterState={filterState}
        setFilterState={setFilterState}
        resetHandler={resetHandler}
        dateRange={dateFilterValues}
        setDates={setDates}
        headerTitle={
          location.pathname.includes("regions")
            ? `My Regions | ${pagination.totalCount} Regions`
            : ` ${fetchBranchHeader()}`
        }
        branchOrRegionId={
          location.pathname.includes("regions")
            ? null
            : location.pathname.split("/")[
                location.pathname.split("/").length - 1
              ]
        }
        subjectFilterIncluded={
          location.pathname.includes("regions") ? false : true
        }
      />
      <FacultyHealthHeader
        mode="regionFaculties"
        aggregatedDataLoading={tableloading}
        aggregatedData={processResponseForCardData(cardAggregatedData, [])}
      />
      <div className={["xs", "sm", "md"].includes(screen) ? "" : "pl-5 pb-1"}>
        {returnComponent(
          location.pathname.includes("regions") ? "regions" : "branches"
        )}
      </div>
      {returnPaginationComponent(
        location.pathname.includes("regions") ? "regions" : "branches"
      )}
    </>
  );
}

export default FacultiesMain;
